let getTokenSilentlyFn = null;
let logoutFn = null;

export const authTokenProvider = {
    initialize(getTokenSilently, logout) {
        getTokenSilentlyFn = getTokenSilently;
        logoutFn = logout;
    },

    async getToken(options) {
        if (!getTokenSilentlyFn) {
            throw new Error("Auth0 token getter not initialized");
        }

        try {
            return await getTokenSilentlyFn(options);
        } catch (error) {
            console.error("Failed to get Auth0 token:", error);

            try {
                if (logoutFn) {
                    logoutFn({
                        logoutParams: {
                            returnTo: window.location.href,
                        },
                    });
                } else {
                    window.location.reload();
                }
            } catch (logoutError) {
                console.error("Logout failed:", logoutError);
                window.location.reload();
            }

            throw error;
        }
    },
};